import { defineStore } from 'pinia';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

export const getId = defineStore('token', {
  state: () => ({
    userId: null,
  }),
  actions: {
    decodeToken(token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      const payload = JSON.parse(jsonPayload);
      this.userId = payload.sub;
    },
    initUserFromCookie() {
      const token = getCookie('token');
      if (token) {
        this.decodeToken(token);
      } else {
        console.warn('Aucun token trouvé dans les cookies');
        this.userId = null;
      }
    },
    clearUser() {
      this.userId = null;
    }
  },
});